var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17188 7.43945L12.0019 12.5495L20.7719 7.46945",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6091V12.5391",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93062 2.4793L4.59063 5.4393C3.38063 6.1093 2.39062 7.7893 2.39062 9.1693V14.8193C2.39062 16.1993 3.38063 17.8793 4.59063 18.5493L9.93062 21.5193C11.0706 22.1493 12.9406 22.1493 14.0806 21.5193L19.4206 18.5493C20.6306 17.8793 21.6206 16.1993 21.6206 14.8193V9.1693C21.6206 7.7893 20.6306 6.1093 19.4206 5.4393L14.0806 2.4693C12.9306 1.8393 11.0706 1.8393 9.93062 2.4793Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.0959f502e03c6b4802cb4574ba0a28af.svg";
export { ForwardRef as ReactComponent };